export const makeFullLink = (path: string): string => {
  // Ensure path starts with /
  return path.startsWith('/') ? path : `/${path}`;
};
